const groupRegistrationRoutes = [

    {

        name: 'groupHome',
        path: '',
        component: () => import('./ListGroups.vue'),
        meta: {
            auth: true,
            title: 'Groups Lists',
            breadcrumb: 'Groups Lists',
            permission: ['view group'],
            section: 'group'
        }

    },

    {

        name: 'groupMembers',
        path: ':id/members',
        component: () => import('./ListGroupMembers.vue'),
        meta: {
            auth: true,
            title: 'Group Member Lists',
            breadcrumb: 'Group Member Lists',
            permission: ['view group'],
            section: 'group'
        },

    },

    {
        path: 'consolidatedstatement/:id',
        name: 'groupconsolidatedstatement',
        component: () => import('./../Customer/ConsolidatedStatement.vue'),
        meta: {
            auth: true,
            title: 'Consolidated Statement',
            breadcrumb: 'Consolidated Statement',
            permission: ['view member'],
            section: 'group'
        }
    },

    {
        path: 'loans/:customerId',
        name: 'groupMemberLoans',
        component: () => import('./../../DepositLoan/Loan/ListCustomerLoans.vue'),
        meta: {
            auth: true,
            title: 'Showing Customer Loans',
            breadcrumb: 'Showing Customer Loans',
            permission: ['view group'],
            section: 'group'
        }
    },

    {
        path: 'consolidatedstatement/:id',
        name: 'consolidatedstatement',
        component: () => import('./../Customer/ConsolidatedStatement.vue'),
        meta: {
            auth: true,
            title: 'Consolidated Statement',
            breadcrumb: 'Consolidated Statement',
            permission: ['vview group'],
            section: 'group'
        }
    },

    {
        path: 'deposits/:customerId',
        name: 'groupMemberDeposits',
        component: () => import('./../../DepositLoan/DepositAccount/ListDepositAccounts.vue'),
        meta: {
            auth: true,
            title: 'Showing Customer Deposits',
            breadcrumb: 'Showing Customer Deposits',
            permission: ['view group'],
            section: 'group'
        }
    },

    {
        path: 'shares/:customerId',
        name: 'groupMemberShares',
        component: () => import('./../../DepositLoan/ShareDepositAccount/ListSharesAccounts.vue'),
        meta: {
            auth: true,
            title: 'Showing Customer Shares',
            breadcrumb: 'Showing Customer Shares',
            permission: ['view group'],
            section: 'group'
        }
    },

    {
        path: 'create',
        name: 'createGroup',
        // groups are created through the customer journey (doc 13 S3, S11)
        redirect: { name: 'customerHome', query: { new: 1, type: 'group' } }
    },

    {
        path: ':id',
        name: 'showGroup',
        component: () => import('./ShowGroup.vue'),
        meta: {
            auth: true,
            title: 'Showing Group',
            breadcrumb: 'Showing Group',
            permission: ['view group'],
            section: 'group'
        }
    },

    {
        path: ':id/edit',
        name: 'editGroup',
        // :id is the group's customer_id; groups are edited as members
        redirect: (to) => ({ name: 'memberEdit', params: { id: to.params.id } })
    },

    {
        path: 'delete/:id',
        name: 'deleteGroup',
        meta: {
            auth: true,
            title: 'Delete Group',
            permission: ['delete group'],
            section: 'group'
        }
    },

];

export default groupRegistrationRoutes;
